module.exports = __webpack_public_path__ + "img/widget.aa732d0d.png";